import React from 'react';
import { Form, Input, Select, Row, Col, Button, Upload, Icon } from 'antd';
import { uploadAdsModalImage } from '../../modules/Api';
import { END_POINT } from '../../constants/config';

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class FooterForm extends React.Component {
    constructor() {
        super();
        this.state = {
            link: "",
            alt: "",
            image: null,
            status: 0,
        }
    }

    componentDidMount() {
        this.setState({
            link: "",
            alt: "",
            image: null,
            status: 0,
        })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.initialData.image && this.state.image === null) {
            this.setState({ image: nextProps.initialData.image });
        }
        if (nextProps.initialData.link && this.state.link === "") {
            this.setState({ link: nextProps.initialData.link });
        }
        if (nextProps.initialData.alt && this.state.alt === "") {
            this.setState({ alt: nextProps.initialData.alt });
        }
        if (nextProps.initialData.status && this.state.status === "") {
            this.setState({ status: nextProps.initialData.status });
        }
    }
    handleSubmit = e => {

        e.preventDefault();
        if (this.submittedAt > Date.now() - 500) {
            return;
        }
        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue, {
                image: this.state.image,
            }));

        })
    }


    render() {
        var img = ""
        if (this.state.image != null) {
            img = <img src={`${this.state.image.includes('http') ? this.state.image : END_POINT + this.state.image}`}
                style={{ width: '150px', height: '50px', margin: '10px' }}
                alt="modal"
            />

        } else if (this.props.initialData.image != null) {
            img = <img src={`${this.props.initialData.image.includes('http') ? this.props.initialData.image : END_POINT + this.props.initialData.image}`}
                style={{ width: '150px', height: '50px', margin: '10px' }}
                alt="modal"
            />
        }
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{ direction: 'rtl' }}>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={9} offset={1}>
                            <FormItem
                                {...formItemLayout}
                                label="عکس بنر"
                                extra="	750 × 120 px  اندازه پیشنهادی "
                                colon={false}>
                                {getFieldDecorator('image', {
                                    initialValue: this.props.initialData.image ? this.props.initialData.image : null,
                                    rules: [{
                                        required: true,
                                    }],
                                    valuePropName: 'fileListImage',
                                    getValueFromEvent: this.normFileImage,
                                })(
                                    <Upload
                                        name="image"
                                        action=""
                                        customRequest={() => { }}
                                        onChange={f => { uploadAdsModalImage(f, (src) => { this.setState({ image: src }) }) }}
                                        listType="picture"
                                        showUploadList={false}>
                                        <Button>
                                            <Icon type="upload" /> انتخاب فایل
                                        </Button>
                                        <br />
                                        {img}
                                    </Upload>
                                )}
                            </FormItem>
                        </Col>

                        <Col span={11} offset={1}>
                            <FormItem
                                {...formItemLayout}
                                label={"لینک"}
                                colon={true} >
                                {getFieldDecorator('link', {
                                    initialValue: this.props.initialData.link ? this.props.initialData.link : null,
                                    rules: [{
                                        required: true,
                                        message: 'لینک بنر: ',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6} offset={4}>
                            <FormItem
                                {...formItemLayout}
                                label="وضعیت"
                                colon={false}>
                                {getFieldDecorator('is_active', {
                                    rules: [{
                                        required: true,
                                        message: 'تگ آلت: ',
                                    }],
                                })(
                                    <Select defaultValue="1" placeholder="وضعیت تبلیغ" style={{ width: '200px' }}>
                                        <Select.Option value="0">غیرفعال</Select.Option>
                                        <Select.Option value="1">فعال</Select.Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6} offset={6}>
                            <FormItem
                                {...formItemLayout}
                                label={"تگ آلت"}
                                colon={true} >
                                {getFieldDecorator('alt', {
                                    initialValue: this.props.initialData.alt ? this.props.initialData.alt : null,
                                    rules: [{
                                        required: true,
                                        message: 'تگ آلت: ',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <FormItem>
                        <div className="btn-container">
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            >
                                {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                            </Button>
                        </div>
                    </FormItem>
                </Form>
            </div>
        )
    }
}
FooterForm.defaultValue = {
    initialData: {}
}

export default Form.create()(FooterForm);



// WEBPACK FOOTER //
// ./src/containers/FooterBanner/form.js